import { render, staticRenderFns } from "./UpdateIcon.vue?vue&type=template&id=31bab072&"
import script from "./UpdateIcon.vue?vue&type=script&lang=js&"
export * from "./UpdateIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports